import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Subcategoria`

export function buscarTodosPorIdCategoria(idCategoria, esScrap = false, buscar = '') {
  return http.get(
    `${API_ENDPOINT}/BuscarTodosPorIdCategoria/${idCategoria}/${esScrap}/${buscar}`,
    {
      meta: {
        toastMessage: 'Ocurrió un error al obtener las subcategorías.',
        tipoError: 'subcategorias'
      }
    }
  )
}
